import { createSlice } from '@reduxjs/toolkit'

const initialState: any = {
    onboardListData: [],
}

const onboardListingSlice = createSlice({
    name: 'onboardListing',
    initialState,
    reducers: {
        setOnboardListing: (state, action) => {
            return { ...state, ...action.payload };
        }
    },
});

export const { setOnboardListing } = onboardListingSlice.actions;

export default onboardListingSlice.reducer